import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import './assets/scss/DefaultTheme.scss';
import { ClearPersistedStorage } from './components/MembershipImpersonation/MembershipImpersonationContext';
import settings from './config';
import { RouteProvider } from './routes';
import Router, { history } from './routes/Router';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from './components/ApplicationInsights';

const onRedirectCallback = appState => {
    ClearPersistedStorage();
    history.push(
        appState 
        && appState.targetUrl
          ? appState.targetUrl
          : window.location.pathname
  );
};

const providerWrappers: ((children: React.ReactNode) => JSX.Element)[] = [
    children => <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>,
    children => (
        <Auth0Provider
            useRefreshTokens={true}
            useRefreshTokensFallback={true}
            domain={settings.AUTH0.DOMAIN}
            clientId={settings.AUTH0.CLIENT_ID}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: settings.AUTH0.AUDIENCE,
            }}
            onRedirectCallback={onRedirectCallback}
            cacheLocation="localstorage"            
        >{children}</Auth0Provider>
    ),
    children => <RouteProvider>{children}</RouteProvider>
]

const App = () => {
    return providerWrappers
        .reverse()
        .reduce(
            (current, providerWrapper) => providerWrapper(current),
            <>
                <ToastContainer/>
                <Router/>
           </>
        )
};


export default App;